import _ from 'lodash';
import React, { Component } from 'react';

import { CircularProgress, withStyles } from '@material-ui/core';
import Zoom from '@material-ui/core/Zoom';
import ErrorIcon from '@material-ui/icons/Error';
import { generalStyles } from '../util';
import { dialogStyles } from './dialogStyles';

const styles = () => {
	return {
		...generalStyles,
		...dialogStyles,
		isSaving: {
			marginLeft: 10,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 10,
			color: '#2E7D32',
		},
		savingError: {
			marginLeft: 10,
			color: '#E53935',
		},

		errorIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			color: '#E53935',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		dialogRedoButton: {
			...dialogStyles.dialogSecondaryButton,
			marginTop: 0,
			minWidth: '30%',
		},
		scanDocumentButton: {
			fontWeight: 'bold',
			fontSize: '100%',
			//backgroundColor: stlBlue,
			color: 'white',
			padding: `3.33vw 5.8vw`,
			lineHeight: 1,
			borderRadius: 4,
			marginTop: '1.4vw',
			//minWidth: '30vw',
		},
	};
};

class MobileDeliveryDialogSavePopup extends Component {
	render() {
		const {
			classes,
			isSaving,
			hasSavingSuccess,
			hasSavingError,
			savingError,
			savingSuccess,
		} = this.props;

		const isOpen = isSaving || hasSavingSuccess || hasSavingError;

		return (
			<div
				style={{
					//transition: '250ms',
					position: 'absolute',
					//top: 10,
					height: isOpen ? '5vw' : 0,
					left: 0,
					right: 0,
					top: isOpen ? '-5vw' : 0,
					//right: 0,
					background: 'rgba(245,245,245,1)',
					display: 'flex',
					zIndex: 99,
					bottom: 0,
					alignContent: 'center',
					justifyContent: 'center',
					justifyItems: 'center',
					fontSize: '120%',
				}}
			>
				<Zoom
					in={isSaving}
					style={{
						transitionDelay: isSaving ? '0ms' : '0ms',
						position: 'absolute',
						marginTop: '1vw',
					}}
					mountOnEnter
					unmountOnExit
				>
					<div className={classes.isSaving}>
						<CircularProgress style={{ verticalAlign: 'middle' }} size="4vw" />
						<span style={{ paddingLeft: 10 }}>Saving...</span>
					</div>
				</Zoom>

				<Zoom
					in={hasSavingSuccess}
					style={{
						transitionDelay: hasSavingSuccess ? '250ms' : '0ms',
						marginTop: '1.5vw',
						position: 'absolute',
					}}
				>
					<div className={classes.savingSuccessful}>
						<div className={classes.greenCheckedIcon} />
						<span style={{ paddingLeft: '1vw' }}>{savingSuccess}</span>
					</div>
				</Zoom>

				<Zoom
					in={hasSavingError}
					style={{
						transitionDelay: hasSavingError ? '250ms' : '0ms',
						marginTop: '1.5vw',
						position: 'absolute',
					}}
				>
					<div className={classes.savingError}>
						<ErrorIcon className={classes.errorIcon} />
						<span style={{ paddingLeft: 10 }}>{savingError}</span>
					</div>
				</Zoom>
			</div>
		);
	}
}

export default _.flow([withStyles(styles)])(MobileDeliveryDialogSavePopup);
